import React, { useEffect } from 'react'
import TableProcedures from './TableProcedures'
import Options from './Options'

//images
import buildingIcon from '../../../../assets/img/pages/icons/building.png'

function Table(props) {

    const handleToggleRow = rowId => {
        let rows = document.querySelectorAll('tr')

        for (let i = 0; i < rows.length; i++) {
            if (rows[i].getAttribute('data-row') == rowId) {
                if (document.querySelector(`tr[data-row="${rowId}"]`).classList.contains('active')) {
                    document.querySelector(`tr[data-row="${rowId}"]`).classList.remove('active')
                } else rows[i].classList.add('active')
            }
        }

    }

    return (
        <table>
            <thead>
                <tr>
                    <th>
                        Последна дата от заявление
                    </th>
                    <th>
                        Обект
                    </th>
                    <th>
                        Адрес
                    </th>
                    <th>
                        Собственик
                    </th>
                    <th>
                        Фирма
                    </th>
                    <th className="options">Опции</th>
                </tr>
            </thead>
            <tbody>
                {props.data.map(p =>
                    <React.Fragment key={'p-' + p.group.id}>
                        <tr className={p.has_closing_procedure ? 'expiring' : ''}>

                            <td onClick={() => handleToggleRow(p.group.id)}>
                                {p.last_request_date}
                            </td>

                            <td onClick={() => handleToggleRow(p.group.id)}>
                                <img src={buildingIcon} alt="Building" />
                                {[
                                    p.group.type ? `${p.group.type.name}` : '',
                                    p.group.activity ? ` - ${p.group.activity.name}` : '',
                                    p.group.name ? ` - ${p.group.name}` : ''
                                ].filter(el => el !== '').join(' ')}

                            </td>

                            <td onClick={() => handleToggleRow(p.group.id)}>
                                {p.group && p.group.town
                                    ? [
                                        p.group.town.name,
                                        p.group.street
                                            ? p.group.street.suff + ' ' + p.group.street.name
                                            : '',
                                        p.group.street_number ? p.group.street_number : '',
                                        p.group.block ? `бл. ${p.group.block}` : '',
                                        p.group.entrance ? `вх. ${p.group.entrance}` : '',
                                        p.group.floor ? `ет. ${p.group.floor}` : '',
                                        p.group.apartment ? `ап. ${p.group.apartment}` : '',
                                    ].filter(el => el !== '').join(', ')
                                    : ''}
                            </td>

                            <td onClick={() => handleToggleRow(p.group.id)}>
                                {p.group && p.group.owner ?
                                    p.group.owner
                                    :
                                    '-'
                                }
                            </td>

                            <td onClick={() => handleToggleRow(p.group.id)}>
                                {p.company && p.company.name ?
                                    p.company.name
                                    :
                                    '-'
                                }
                            </td>
                            <td>
                                <Options
                                    id={p.trade_object_procedure_id}
                                    phaseId={p.phase_id}
                                    changeable={p.changeable}
                                    hasClosingProcedure={p.has_closing_procedure}
                                    refreshData={props.refreshData}
                                />
                            </td>
                        </tr>

                        <tr className={["collapsable", props.selected && p.items.filter(i => i.id == props.selected).length ? 'active' : ''].join(' ')} data-row={p.group.id}>
                            {p.items.length > 0 ?
                                <td colSpan="10">
                                    <TableProcedures
                                        tabGroup={props.tabGroup}
                                        data={p.items}
                                        selected={props.selected}
                                        hasClosingProcedure={p.has_closing_procedure}
                                        refreshData={props.refreshData}
                                    />
                                </td>
                                :
                                <td className="no-procedures">
                                    Няма процедури.
                                </td>
                            }
                        </tr>

                    </React.Fragment>
                )}
            </tbody>
        </table>
    )
}

export default Table